import InterviewQuestion from './InterviewQuestion.container';

export default InterviewQuestion;
